import { css } from "@emotion/react";

export const sectionStyle = css`
  margin-bottom: 16px;
`;

export const nodeEditorStyle = css`
  border: 1px solid #1890ff;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
`;

export const nodeBlockStyle = css`
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
  position: relative;
`;

export const nodeTitleStyle = css`
  color: #1890ff;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const removeIconStyle = css`
  position: absolute;
  top: 12px;
  right: 12px;
  color: #ff4d4f;
  cursor: pointer;
`;

export const fullWidthStyle = css`
  width: 100%;
`;

export const tagListStyle = css`
  margin-top: 8px;
`;

export const ellipsisCellStyle = css`
  max-width: 240px;
  margin-bottom: 0 !important;
`;

export const floatRightStyle = css`
  float: right;
`;

export const optionTableStyle = css`
  width: 100%;
`;

export const thumbnailPreviewStyle = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
